import axios from 'axios';
import { handleRequest } from 'helpers/api';

const FILES_URL = `${process.env.REACT_APP_API_URL}/files`;

axios.defaults.withCredentials = true;

const filesApi = axios.create({
  baseURL: FILES_URL,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

export const uploadFile = async (file: FormData) => {
  return handleRequest(filesApi.post('/images', file));
};

export const uploadMultipleFiles = async (files: FormData) => {
  return handleRequest(filesApi.post('/multi-images', files));
};
